import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";

import {
    AVATAR_BASE_URL_API,
    BANNER_BASE_URL_API,
    BASE_URL_API,
    MARKET_BASE_URL_API,
    PRODUCT_BASE_URL_API
} from "../Const";
import {BasketComponent} from "./BasketComponent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {Link} from "react-router-dom";
import Paper from "@mui/material/Paper";
import {ProductStructList} from "../structs/ProductStructList";
import {ProductStruct} from "../structs/ProductStruct";
import Box from "@mui/material/Box";
import {MarketStructList} from "../structs/MarketStructList";
import {MarketStruct} from "../structs/MarketStruct";
import Typography from "@mui/material/Typography";
import {styled} from "@mui/material/styles";
import AliceCarousel from "react-alice-carousel";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {Grid} from "@mui/material";
import AvatarIcon from "../assets/icons/avatar.svg";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AddCardIcon from "@mui/icons-material/AddCard";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ReduceCapacityOutlinedIcon from "@mui/icons-material/ReduceCapacityOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import SearchIcon from "@mui/icons-material/Search";
import {BottomMenu} from "./HookUtils";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import Chip from "@mui/material/Chip";
import LoadingSplash from "./commoncComponent/LoadingSplash";

// ✅ Swiper (for discount widget only)
import {Swiper, SwiperSlide} from "swiper/react";
import {Mousewheel, FreeMode} from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

import "../style/OfferComponent.css";

const drawerWidth = 240;
const DrawerHeader = styled("div")(({theme}) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
}));

export class OfferComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchResultProduct: [],
            searchResultMarket: [],
            banners: [],
            userData: null,
            open: false,
            isLoading: true,
            loadingVisible: true,

            // ✅ widgets (from home/widgets)
            widgetDiscount: [],
            widgetNewest: [],
            widgetBestSell: [],

            discountTimer: "00:00:00",
            activeMarkets: [],
            activeMarketIndex: 0,
        };

        this.loadingRef = React.createRef();
        this.timerInterval = null;

        this.WIDGET_ENDPOINT = "home/widgets";
        this.LIMIT = 12; // فقط برای گرفتن ویجت‌ها (چون pagination نداری)
    }

    /* ---------------- helpers ---------------- */

    toInt = (v) => {
        const n = parseInt(v, 10);
        return Number.isFinite(n) ? n : 0;
    };

    formatStep = (val) => {
        const num = Number(val);
        if (!isFinite(num) || num <= 0) return "";
        return parseFloat(num.toFixed(4)).toLocaleString("en", {maximumFractionDigits: 4});
    };

    formatTomans = (val) =>
        this.toInt(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان ";

    calcFinalPriceByPercent = (price, sellerDiscountPercent) => {
        const p = this.toInt(price);
        const d = this.toInt(sellerDiscountPercent);
        if (p <= 0 || d <= 0) return p;
        const final = Math.round((p * (100 - d)) / 100);
        return final < 0 ? 0 : final;
    };

    bubbleSort(arr, n) {
        var i, j, temp;
        for (i = 0; i < n - 1; i++) {
            for (j = 0; j < n - i - 1; j++) {
                if (arr[j].productList.length < arr[j + 1].productList.length) {
                    temp = arr[j];
                    arr[j] = arr[j + 1];
                    arr[j + 1] = temp;
                }
            }
        }
        return arr;
    }

    /* ---------------- timer ---------------- */

    startDiscountTimer = () => {
        const update = () => {
            const now = new Date();
            const end = new Date();
            end.setHours(23, 59, 59, 999);

            const diff = Math.max(0, end.getTime() - now.getTime());
            const totalSec = Math.floor(diff / 1000);

            const h = String(Math.floor(totalSec / 3600)).padStart(2, "0");
            const m = String(Math.floor((totalSec % 3600) / 60)).padStart(2, "0");
            const s = String(totalSec % 60).padStart(2, "0");

            this.setState({discountTimer: `${h}:${m}:${s}`});
        };

        update();
        this.timerInterval = setInterval(update, 1000);
    };

    fetchActiveMarkets = () => {
        fetch(BASE_URL_API + "markets", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((r) => r.json())
            .then((res) => {
                const list = Array.isArray(res?.data) ? res.data : [];
                const filtered = list
                    .filter((m) => m?.status === "ok")
                    .filter((m) => Array.isArray(m?.pictures) && m.pictures.length > 0 && m.pictures[0]?.url);

                // مرتب‌سازی: تازه‌ترین آپدیت‌ها اول
                filtered.sort((a, b) => new Date(b.updated_at || 0) - new Date(a.updated_at || 0));

                this.setState({activeMarkets: filtered});
            })
            .catch((e) => console.log("markets error:", e));
    };

    /* ---------------- widgets api (your format: data.widgets[]) ---------------- */

    getWidgetByType = (widgets, type) => {
        if (!Array.isArray(widgets)) return null;
        return widgets.find((w) => w && w.type === type) || null;
    };

    fetchWidgets = () => {
        const url = `${BASE_URL_API}${this.WIDGET_ENDPOINT}?limit=${this.LIMIT}`;

        fetch(url, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((res) => {
                if (res.code !== 200) return;

                const widgets = res?.data?.widgets || [];
                const discountW = this.getWidgetByType(widgets, "discount_week");
                const newestW = this.getWidgetByType(widgets, "newest");
                const bestW = this.getWidgetByType(widgets, "best_seller");

                this.setState({
                    widgetDiscount: Array.isArray(discountW?.items) ? discountW.items : [],
                    widgetNewest: Array.isArray(newestW?.items) ? newestW.items : [],
                    widgetBestSell: Array.isArray(bestW?.items) ? bestW.items : [],
                });
            })
            .catch((e) => console.log("home/widgets error:", e));
    };

    /* ---------------- widgets renderers ---------------- */

    // ✅ Discount widget (pasaj style)
    renderPasajDiscountWidget = () => {
        const list = this.state.widgetDiscount || [];
        if (!Array.isArray(list) || list.length === 0) return null;

        return (
            <div className="offer-widget-wrap">
                <div className="offer-widget-frame offer-red">
                    <div className="offer-widget-inner offer-row">
                        {/* ✅ RIGHT banner (RTL) */}
                        <div className="offer-widget-banner">
                            <div className="offer-widget-banner-title">پر تخفیفی‌های هفته</div>
                            <div className="offer-widget-banner-sub">از حراج ها جا نمونی!</div>
                            <div className="offer-widget-banner-timer">پایان تا {this.state.discountTimer}</div>

                            <Link to="/search?discount=1" className="offer-widget-banner-btn">
                                بیشتر
                            </Link>
                        </div>

                        {/* ✅ LEFT slider */}
                        <div className="offer-swiper-wrap">
                            <Swiper
                                modules={[Mousewheel, FreeMode]}
                                slidesPerView={"auto"}
                                spaceBetween={14}
                                freeMode={{enabled: true, momentum: true, momentumRatio: 0.85, momentumBounce: false}}
                                mousewheel={{forceToAxis: true, sensitivity: 0.6, releaseOnEdges: true}}
                                resistanceRatio={0.25}
                                touchRatio={1.15}
                                longSwipesRatio={0.15}
                                direction="horizontal"
                            >
                                {list.map((p) => {
                                    const discountPercent = this.toInt(p?.seller_discount);
                                    const originalPrice = this.toInt(p?.price);
                                    const finalPrice = this.calcFinalPriceByPercent(originalPrice, discountPercent);

                                    const img =
                                        p?.pictures?.length > 0
                                            ? PRODUCT_BASE_URL_API + p.pictures[0].url
                                            : "hamekara-logo.png";

                                    return (
                                        <SwiperSlide key={p.id} className="offer-slide">
                                            <Link to={`/product?id=${p.id}`} className="offer-card offer-card-week">
                                                <div className="offer-card-media offer-media-week">
                                                    <img src={img} alt={p.title || ""}/>
                                                </div>

                                                <div className="offer-card-body">
                                                    <div className="offer-card-title">{p.title}</div>

                                                    <div className="offer-card-price">
                                                        {p?.is_price_visible === false || p?.is_price_visible === 0 ? (
                                                            <div className="offer-price-new">
                                                                تماس بگیرید
                                                            </div>
                                                        ) : discountPercent > 0 && originalPrice > 0 ? (
                                                            <>
                                                                <div className="offer-row-price">
                                                                    <span
                                                                        className="offer-pill">%{discountPercent}</span>
                                                                    <span className="offer-price-old">
                                                                       {this.formatTomans(originalPrice)}
                                                                     </span>
                                                                </div>

                                                                <div className="offer-price-new">
                                                                    {this.formatTomans(finalPrice)}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="offer-price-new">
                                                                {originalPrice > 0
                                                                    ? this.formatTomans(originalPrice)
                                                                    : "تماس بگیرید"}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </Link>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>

                            {this.state.loadingDiscount && (
                                <Box sx={{display: "flex", justifyContent: "center", mt: 1}}>
                                    <CircularProgress size={26} sx={{color: "#fff"}}/>
                                </Box>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // ✅ Newest (keep your circle strip)
    renderNewestWidget = () => {
        const list = this.state.widgetNewest || [];
        if (!Array.isArray(list) || list.length === 0) return null;

        return (
            <div className="strip-widget">
                <div className="strip-header">
                    <div className="strip-title-wrap">
                        <div className="strip-title">جدیدترین‌ها</div>
                        <div className="strip-subtitle">تازه اضافه شده</div>
                    </div>

                    <Link to="/search?sort=newest" className="strip-more">
                        بیشتر
                    </Link>
                </div>

                <div className="strip-body">
                    <Swiper
                        modules={[Mousewheel, FreeMode]}
                        slidesPerView={"auto"}
                        spaceBetween={14}
                        freeMode={{enabled: true, momentum: true, momentumRatio: 0.85, momentumBounce: false}}
                        mousewheel={{forceToAxis: true, sensitivity: 0.6, releaseOnEdges: true}}
                        resistanceRatio={0.25}
                        touchRatio={1.15}
                        longSwipesRatio={0.15}
                        direction="horizontal"
                    >
                        {list.map((p) => {
                            const img =
                                p?.pictures?.length > 0
                                    ? PRODUCT_BASE_URL_API + p.pictures[0].url
                                    : "hamekara-logo.png";

                            return (
                                <SwiperSlide key={p.id} className="strip-slide">
                                    <Link to={`/product?id=${p.id}`} className="strip-item">
                                        <div className="strip-avatar">
                                            <img src={img} alt={p.title || ""}/>
                                        </div>
                                        <div className="strip-item-title">{p.title}</div>
                                    </Link>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            </div>
        );
    };

    // ✅ BestSell like Digikala (NO swiper, native scroll)
    renderBestSellWidget = () => {
        const list = this.state.widgetBestSell || [];
        if (!Array.isArray(list) || list.length === 0) return null;

        // group items by 2 (Digikala style)
        const groups = [];
        for (let i = 0; i < list.length; i += 2) {
            groups.push(list.slice(i, i + 2));
        }

        return (
            <div className="dk-grid-widget">
                <div className="dk-grid-header">
                    <div className="dk-grid-title">
                        <span className="dk-fire">🔥</span>
                        پرفروش‌ترین کالاها
                    </div>

                    <Link to="/search?sort=best_sell" className="dk-grid-more">
                        مشاهده همه
                    </Link>
                </div>

                <div className="dk-grid-body">
                    <Swiper
                        modules={[Mousewheel, FreeMode]}
                        slidesPerView={"auto"}
                        spaceBetween={14}
                        freeMode={{enabled: true, momentum: true, momentumRatio: 0.85, momentumBounce: false}}
                        mousewheel={{forceToAxis: true, sensitivity: 0.6, releaseOnEdges: true}}
                        resistanceRatio={0.25}
                        touchRatio={1.15}
                        longSwipesRatio={0.15}
                        direction="horizontal"
                    >
                        {groups.map((group, groupIndex) => (
                            <SwiperSlide key={groupIndex} className="dk-grid-slide">
                                <div className="dk-grid-column">
                                    {group.map((p, idx) => {
                                        const rank = groupIndex * 2 + idx + 1;
                                        const img =
                                            p?.pictures?.length > 0
                                                ? PRODUCT_BASE_URL_API + p.pictures[0].url
                                                : "hamekara-logo.png";

                                        return (
                                            <Link
                                                key={p.id}
                                                to={`/product?id=${p.id}`}
                                                className="dk-grid-item"
                                            >
                                                <div className="dk-grid-rank">{rank}</div>

                                                <div className="dk-grid-thumb">
                                                    <img src={img} alt={p.title || ""}/>
                                                </div>

                                                <div className="dk-grid-info">
                                                    <div className="dk-grid-name">
                                                        {p.title}
                                                    </div>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        );
    };

    renderActiveMarketsStories = () => {
        const {activeMarkets, activeMarketIndex} = this.state;
        if (!Array.isArray(activeMarkets) || activeMarkets.length === 0) return null;

        return (
            <div className="story-strip-wrap">
                <div className="story-strip">
                    <Swiper
                        modules={[Mousewheel, FreeMode]}
                        slidesPerView={"auto"}
                        spaceBetween={14}
                        freeMode={{enabled: true, momentum: true, momentumRatio: 0.85, momentumBounce: false}}
                        mousewheel={{forceToAxis: true, sensitivity: 0.6, releaseOnEdges: true}}
                        resistanceRatio={0.25}
                        touchRatio={1.15}
                        longSwipesRatio={0.15}
                        direction="horizontal">

                        {activeMarkets.map((m, idx) => {
                            const img = (m?.pictures?.[0]?.url)
                                ? (MARKET_BASE_URL_API + m.pictures[0].url)
                                : "hamekara-logo.png";

                            const isActive = idx === activeMarketIndex;

                            const href = (m?.slug && String(m.slug).trim() !== "")
                                ? `/${m.slug}`
                                : null;

                            return (
                                <SwiperSlide key={m.id} className="story-slide">
                                    {href ? (
                                        <a
                                            href={href}
                                            target="_blank"
                                            rel="noreferrer"
                                            className={`story-item ${isActive ? "is-active" : ""}`}
                                            title={m.name}
                                        >
                                            <div className="story-ring">
                                                <div className="story-avatar">
                                                    <img
                                                        src={img}
                                                        alt={m.name || ""}
                                                        onError={(e) => {
                                                            e.currentTarget.src = "/hamekara-logo.png";
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="story-title">{m.name}</div>
                                        </a>
                                    ) : (
                                        <Link
                                            to={`/market?id=${m.id}`}
                                            className={`story-item ${isActive ? "is-active" : ""}`}
                                            title={m.name}
                                        >
                                            <div className="story-ring">
                                                <div className="story-avatar">
                                                    <img
                                                        src={img}
                                                        alt={m.name || ""}
                                                        onError={(e) => {
                                                            e.currentTarget.src = "/hamekara-logo.png";
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="story-title">{m.name}</div>
                                        </Link>
                                    )}
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            </div>
        );
    };

    /* ---------------- lifecycle ---------------- */


    componentDidMount() {
        this.loadingRef.current?.show("درحال بارگزاری محصولات...");

        this.fetchActiveMarkets();
        this.startDiscountTimer();
        this.fetchWidgets();

        // ---------------- original search ----------------
        fetch(BASE_URL_API + "search?q=", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then(
                (results) => {
                    if (results.code === 200) {
                        let data = new ProductStructList();

                        for (let i = 0; i < results.data.products.length; i++) {
                            if (data.productList.length > 0) {
                                let size = data.productList.length;
                                for (let j = 0; j < size; j++) {
                                    if (
                                        results.data.products[i].category !== null &&
                                        data.productList[j].category === results.data.products[i].category.title
                                    ) {
                                        data.productList[j].productList.push(results.data.products[i]);
                                        break;
                                    } else {
                                        if (j === data.productList.length - 1) {
                                            if (results.data.products[i].category != null) {
                                                let productStruct = new ProductStruct();
                                                productStruct.category = results.data.products[i].category.title;
                                                productStruct.productList.push(results.data.products[i]);
                                                data.productList.push(productStruct);
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (results.data.products[i].category != null) {
                                    let productStruct = new ProductStruct();
                                    productStruct.category = results.data.products[i].category.title;
                                    productStruct.productList.push(results.data.products[i]);
                                    data.productList.push(productStruct);
                                }
                            }
                        }

                        let marketData = new MarketStructList();

                        for (let i = 0; i < results.data.markets.length; i++) {
                            if (marketData.marketList.length > 0) {
                                let size = marketData.marketList.length;
                                for (let j = 0; j < size; j++) {
                                    if (
                                        results.data.markets[i].category !== null &&
                                        marketData.marketList[j].category === results.data.markets[i].category.title
                                    ) {
                                        marketData.marketList[j].marketList.push(results.data.markets[i]);
                                        break;
                                    } else {
                                        if (j === marketData.marketList.length - 1) {
                                            let marketStruct = new MarketStruct();
                                            marketStruct.category = results.data.markets[i].category.title;
                                            marketStruct.marketList.push(results.data.markets[i]);
                                            marketData.marketList.push(marketStruct);
                                        }
                                    }
                                }
                            } else {
                                let marketStruct = new MarketStruct();
                                marketStruct.category = results.data.markets[i].category.title;
                                marketStruct.marketList.push(results.data.markets[i]);
                                marketData.marketList.push(marketStruct);
                            }
                        }

                        const offerList = data.productList.filter((item) => item.category.indexOf("داغ") !== -1);
                        let difference = data.productList.filter((x) => !offerList.includes(x));
                        let finalList = offerList.concat(this.bubbleSort(difference, difference.length));

                        this.setState({
                            searchResultProduct: finalList,
                            searchResultMarket: marketData.marketList,
                            isLoading: false,
                            loadingVisible: false,
                        });

                        this.loadingRef.current?.hide();
                    }
                },
                (error) => {
                    console.log(error);
                    this.loadingRef.current?.hide();
                    this.setState({loadingVisible: false});
                }
            );

        // banners
        fetch(BASE_URL_API + "banner?type=home")
            .then((response) => response.json())
            .then(
                (results) => {
                    this.setState({banners: results.data || []});
                },
                (error) => console.log(error)
            );

        // user
        fetch(BASE_URL_API + "user", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then(
                (results) => {
                    if (results.code === "200" || results.code === 200) {
                        this.setState({userData: results.data});
                    }
                },
                (error) => console.log(error)
            );
    }

    componentWillUnmount() {
        if (this.timerInterval) clearInterval(this.timerInterval);
    }

    /* ---------------- drawer handlers ---------------- */

    handleDrawerClose = () => this.setState({open: false});
    handleDrawerOpen = () => this.setState({open: true});

    /* ---------------- render ---------------- */

    renderProductCard = (p) => {
        const MAX_LENGTH = 25;

        const variants = Array.isArray(p?.variants) ? p.variants : [];
        const hasVariants = variants.length > 0;

        const toInt = (v) => {
            const n = parseInt(v, 10);
            return Number.isFinite(n) ? n : 0;
        };

        const formatTomans = (val) =>
            toInt(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان ";

        const formatStep = (val) => {
            const num = Number(val);
            if (!isFinite(num) || num <= 0) return "";
            return parseFloat(num.toFixed(4)).toLocaleString("en", {
                maximumFractionDigits: 4,
            });
        };

        // ---------------- INVENTORY ----------------
        const totalStock = hasVariants
            ? variants.reduce((sum, v) => sum + Number(v.step || 0), 0)
            : Number(p.step || 0);

// ---------------- VARIANT PRICE ----------------
        let priceBlock = null;

        if (hasVariants) {
            // Variant prices are always hidden when main product
            // has is_price_visible = false
            if (p?.is_price_visible !== false && p?.is_price_visible !== 0) {
                const valid = variants
                    .map((v) => {
                        const base = toInt(v.customer_price);
                        const percent = toInt(v.seller_discount);
                        if (base <= 0) return null;

                        const final =
                            percent > 0
                                ? Math.round((base * (100 - percent)) / 100)
                                : base;

                        return {base, final, percent};
                    })
                    .filter(Boolean);

                if (valid.length > 0) {
                    const bases = valid.map((v) => v.base);
                    const finals = valid.map((v) => v.final);

                    const minBase = Math.min(...bases);
                    const maxBase = Math.max(...bases);

                    const minFinal = Math.min(...finals);
                    const maxFinal = Math.max(...finals);

                    const hasDiscount = valid.some((v) => v.percent > 0);

                    priceBlock = (
                        <Box sx={{mt: "auto"}}>
                            {hasDiscount && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "text.secondary",
                                        textDecoration: "line-through",
                                        direction: "rtl",
                                    }}
                                >
                                    <strong>
                                        {minBase === maxBase
                                            ? formatTomans(minBase)
                                            : `${minBase.toLocaleString()} تا ${formatTomans(maxBase)}`}
                                    </strong>
                                </Typography>
                            )}

                            <Typography
                                variant="body1"
                                sx={{
                                    color: "success.main",
                                    fontWeight: 700,
                                    direction: "rtl",
                                }}
                            >
                                <strong>
                                    {minFinal === maxFinal
                                        ? formatTomans(minFinal)
                                        : `${minFinal.toLocaleString()} تا ${formatTomans(maxFinal)}`}
                                </strong>
                            </Typography>
                        </Box>
                    );
                }
            }
        } else {
            // ---- MAIN PRODUCT LOGIC ----
            if (p?.is_price_visible === false || p?.is_price_visible === 0) {
                priceBlock = (
                    <Box sx={{mt: "auto"}}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "warning.main",
                                fontWeight: 700,
                                direction: "rtl",
                            }}
                        >
                            <strong>تماس بگیرید</strong>
                        </Typography>
                    </Box>
                );
            } else if (toInt(p.del_price) > 0) {
                priceBlock = (
                    <Box sx={{mt: "auto"}}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                textDecoration: "line-through",
                                direction: "rtl",
                            }}
                        >
                            <strong>{formatTomans(p.price)}</strong>
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: "success.main",
                                fontWeight: 700,
                                direction: "rtl",
                            }}
                        >
                            <strong>
                                {formatTomans(
                                    toInt(p.price) - toInt(p.del_price)
                                )}
                            </strong>
                        </Typography>
                    </Box>
                );
            } else {
                priceBlock = (
                    <Box sx={{mt: "auto"}}>
                        <Typography
                            variant="body1"
                            sx={{
                                color:
                                    toInt(p.price) > 0
                                        ? "success.main"
                                        : "warning.main",
                                fontWeight: 700,
                                direction: "rtl",
                            }}
                        >
                            <strong>
                                {toInt(p.price) > 0
                                    ? formatTomans(p.price)
                                    : "تماس بگیرید"}
                            </strong>
                        </Typography>
                    </Box>
                );
            }
        }
        // ---------------- VARIANT BADGE ----------------
        let badge = null;

        if (hasVariants) {
            const attrMap = {};

            variants.forEach((v) => {
                (v.attribute_values || []).forEach((av) => {
                    const attrTitle = av?.attribute?.title;
                    if (!attrTitle) return;

                    if (!attrMap[attrTitle]) {
                        attrMap[attrTitle] = new Set();
                    }
                    attrMap[attrTitle].add(av.value);
                });
            });

            const parts = [`${variants.length} مدل`];

            Object.keys(attrMap).forEach((key) => {
                parts.push(`${attrMap[key].size} ${key}`);
            });

            badge = (
                <Chip
                    label={parts.join(" و ")}
                    size="small"
                    sx={{
                        fontSize: 10,
                        height: 20,
                        alignSelf: "flex-start",
                        bgcolor: "#d32f2f",
                        color: "#fff",
                        fontWeight: 600,
                        direction: "rtl",
                    }}
                />
            );
        }

        // ---------------- UI ----------------
        return (
            <ListItem
                key={p.id}
                component={Link}
                to={"/product?id=" + p.id}
                sx={{width: 250, px: 0, textDecoration: "none", color: "inherit"}}
            >
                <Paper
                    elevation={1}
                    sx={{
                        width: "100%",
                        borderRadius: 2,
                        p: 1.25,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                    }}
                >
                    <Box
                        sx={{
                            width: 140,
                            height: 140,
                            borderRadius: 1.5,
                            overflow: "hidden",
                            bgcolor: "#ffffff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            alignSelf: "center",
                        }}
                    >
                        <Box
                            component="img"
                            alt={p.title}
                            src={
                                p.pictures?.length > 0
                                    ? PRODUCT_BASE_URL_API + p.pictures[0].url
                                    : "hamekara-logo.png"
                            }
                            sx={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </Box>

                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 700,
                            color: "text.primary",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            direction: "rtl",
                        }}
                        title={p.title}
                    >
                        {p.title.length > MAX_LENGTH
                            ? `${p.title.substring(0, MAX_LENGTH)}...`
                            : p.title}
                    </Typography>

                    {badge}

                    <Typography
                        variant="caption"
                        sx={{
                            lineHeight: 1.2,
                            color: totalStock > 0 ? "text.secondary" : "error.main",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            direction: "rtl",
                        }}
                    >
                        {totalStock > 0
                            ? `موجودی: ${formatStep(totalStock)}`
                            : "تماس بگیرید"}
                    </Typography>

                    {priceBlock}
                </Paper>
            </ListItem>
        );
    };

    render() {
        const {loadingVisible} = this.state;

        let drawerOptionLinks = ["/transaction", "/order", "/about-us", "/privacy-policy"];

        const flexContainer = {
            display: "flex",
            flexDirection: "row",
            overflowX: "auto",
            overflowY: "hidden",
            height: 290,
            background: "rgba(238,238,238,0.3)",
            align: "right",
        };

        const MAX_LENGTH = 25;

        const bannerItems = (this.state.banners || []).map((banner, index) => (
            <div key={index} align="center">
                <img
                    style={{marginTop: 55, width: "100%", objectFit: "contain"}}
                    alt=""
                    src={BANNER_BASE_URL_API + banner.picture.url}
                />
            </div>
        ));

        return (
            <>
                <LoadingSplash ref={this.loadingRef}/>

                {!loadingVisible && (
                    <React.Fragment>
                        <AppBar elevation={0} sx={{background: "rgba(238,238,238,0.3)", backdropFilter: "blur(6px)"}}>
                            <ToolbarMui>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="end"
                                    onClick={this.handleDrawerOpen}
                                    sx={{...(this.state.open && {display: "none"})}}
                                    size="large"
                                >
                                    <MenuIcon style={{color: "black"}}/>
                                </IconButton>

                                <ListItemText
                                    align="center"
                                    primary={
                                        <strong
                                            style={{width: "90%", fontSize: 18, whiteSpace: "nowrap", color: "black"}}>
                                            {"Hamekara"}
                                        </strong>
                                    }
                                />

                                <IconButton component={Link} to={"/search"} style={{color: "black"}} size="large">
                                    <SearchIcon/>
                                </IconButton>

                                <IconButton style={{color: "black"}} size="large">
                                    <BasketComponent/>
                                </IconButton>
                            </ToolbarMui>
                        </AppBar>

                        <Drawer
                            anchor="left"
                            open={this.state.open}
                            onClose={this.handleDrawerClose}
                            sx={{
                                "& .MuiDrawer-paper": {
                                    width: drawerWidth,
                                    direction: "rtl",
                                    right: 0,
                                    left: "auto",
                                },
                            }}
                        >
                            <DrawerHeader>
                                <IconButton onClick={this.handleDrawerClose} size="large">
                                    <ChevronRightIcon/>
                                </IconButton>

                                {(this.state.userData === null || this.state.userData.picture === null) ? (
                                    <Grid container>
                                        <Grid xs={12}>
                                            <img style={{marginRight: 16}} alt="avatar2" src={AvatarIcon}/>
                                            {this.state.userData !== null ? (
                                                <Typography
                                                    style={{
                                                        fontWeight: "bold",
                                                        fontSize: 18,
                                                        marginBottom: 18,
                                                        marginRight: 16,
                                                        color: "green",
                                                    }}
                                                >
                                                    {this.state.userData.name}
                                                </Typography>
                                            ) : ""}
                                        </Grid>

                                        {this.state.userData !== null ? (
                                            <React.Fragment>
                                                <Grid xs={2}><PhoneIphoneIcon/></Grid>
                                                <Grid xs={10}>
                                                    <Typography style={{fontSize: 14, color: "gray"}} align="right">
                                                        {this.state.userData.phone}
                                                    </Typography>
                                                </Grid>

                                                <Grid xs={2}><AddCardIcon/></Grid>
                                                <Grid xs={10}>
                                                    <Typography style={{fontSize: 14, color: "gray"}} align="right">
                                                        {this.state.userData.wallet}
                                                    </Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : ""}
                                    </Grid>
                                ) : (
                                    <Grid container>
                                        <Grid xs={12}>
                                            <img
                                                style={{marginRight: 16}}
                                                alt="avatar2"
                                                src={`${AVATAR_BASE_URL_API}${this.state.userData.picture.url}`}
                                            />
                                            <Typography
                                                style={{
                                                    fontWeight: "bold",
                                                    fontSize: 18,
                                                    marginBottom: 18,
                                                    marginRight: 16,
                                                    color: "green",
                                                }}
                                            >
                                                {this.state.userData.name}
                                            </Typography>
                                        </Grid>

                                        <Grid xs={2}><PhoneIphoneIcon/></Grid>
                                        <Grid xs={10}>
                                            <Typography style={{fontSize: 14, color: "gray"}} align="right">
                                                {this.state.userData.phone}
                                            </Typography>
                                        </Grid>

                                        <Grid xs={2}><AddCardIcon/></Grid>
                                        <Grid xs={10}>
                                            <Typography style={{fontSize: 14, color: "gray"}} align="right">
                                                {this.state.userData.wallet}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                )}
                            </DrawerHeader>

                            <Divider style={{marginTop: 50}}/>

                            <List>
                                {["سوابق تراکنش", "سفارشات", "درباره ما", "قوانین و مقررات"].map((text, index) => (
                                    <ListItem button key={text} component={Link} to={drawerOptionLinks[index]}>
                                        <ListItemIcon>
                                            {index === 0 ? <PendingActionsOutlinedIcon/> : ""}
                                            {index === 1 ? <ShoppingBasketOutlinedIcon/> : ""}
                                            {index === 2 ? <ReduceCapacityOutlinedIcon/> : ""}
                                            {index === 3 ? <PrivacyTipOutlinedIcon/> : ""}
                                        </ListItemIcon>
                                        <ListItemText align="right">{text}</ListItemText>
                                    </ListItem>
                                ))}
                            </List>

                            <Divider/>
                        </Drawer>

                        {/* ✅ banners (fixed) */}
                        <AliceCarousel
                            autoPlay
                            autoPlayStrategy="none"
                            autoPlayInterval={2500}
                            animationDuration={900}
                            infinite
                            touchTracking
                            disableButtonsControls
                            disableDotsControls
                            items={bannerItems}
                        />

                        {/* ✅ Widgets */}
                        {/* ✅ stories under banner */}
                        {this.renderActiveMarketsStories()}
                        {this.renderPasajDiscountWidget()}
                        {this.renderNewestWidget()}
                        {this.renderBestSellWidget()}

                        {/* ---- rest of your page unchanged ---- */}
                        <Box sx={{px: 1.5}}>
                            <div align="center">{this.state.isLoading ? <CircularProgress/> : ""}</div>

                            {this.state.searchResultProduct.map((group) => (
                                <Box
                                    key={group.category}
                                    sx={{
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: 2,
                                        border: (t) => `1px solid ${t.palette.divider}`,
                                        pt: 5,
                                        p: 1.5,
                                        mb: 2,
                                    }}
                                >
                                    {group.category && (
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: 0,
                                                insetInlineStart: 16,
                                                transform: "translateY(-1px)",
                                                zIndex: 2,
                                                display: "inline-flex",
                                                alignItems: "center",
                                                px: 1.25,
                                                height: 34,
                                                bgcolor: "#FF1744",
                                                color: "#fff",
                                                fontSize: 14,
                                                fontWeight: 700,
                                                borderRadius: "0 0 14px 14px",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                                                lineHeight: 1,
                                                userSelect: "none",
                                            }}
                                            title={group.category}
                                        >
                                            {group.category}
                                        </Box>
                                    )}

                                    <List style={flexContainer} sx={{px: 1, gap: 1.5}}>
                                        {group.productList.map((p) => this.renderProductCard(p))}
                                    </List>
                                </Box>
                            ))}
                        </Box>

                        <BottomMenu/>

                        {/* footer unchanged */}
                        <Box
                            component="footer"
                            sx={{
                                backgroundColor: "#1e1e1e",
                                color: "#f1f1f1",
                                px: 3,
                                py: 4,
                                mt: 6,
                                fontSize: 14,
                                pb: "70px",
                                textAlign: "center",
                            }}
                        >
                            <Grid container spacing={3} justifyContent="center">
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="h6" sx={{fontWeight: "bold", mb: 1}}>
                                        درباره همه کارا
                                    </Typography>
                                    <Typography variant="body2" sx={{mb: 1}}>
                                        سامانه فروشگاهی <strong>همه کارا</strong> راهکاری نوین برای مدیریت فروشگاه‌های
                                        آنلاین و آفلاین است. با امکانات ثبت سفارش، باشگاه مشتریان، گزارش‌ گیری مالی و
                                        پشتیبانی.
                                    </Typography>
                                    <a
                                        href="https://intro.hamekara.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{color: "#4fc3f7", textDecoration: "none", fontWeight: "bold"}}
                                    >
                                        معرفی کامل همه کارا
                                    </a>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography variant="h6" sx={{fontWeight: "bold", mb: 1}}>
                                        تماس با ما
                                    </Typography>
                                    <Typography variant="body2" sx={{mb: 0.5}}>
                                        📞 0383-228-5853
                                    </Typography>
                                    <Typography variant="body2" sx={{mb: 0.5}}>
                                        📧 thetoptraders@gmail.com
                                    </Typography>
                                    <Typography variant="body2">
                                        📍 ایران - شهرکرد - ساختمان علم و فناوری پردیس - طبقه سوم - واحد 305
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={4}
                                      sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <div className="trust-badge">
                                        <a
                                            referrerPolicy="origin"
                                            target="_blank"
                                            href="https://trustseal.enamad.ir/?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                            rel="noreferrer"
                                        >
                                            <img
                                                referrerPolicy="origin"
                                                src="https://trustseal.enamad.ir/logo.aspx?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                                alt=""
                                                style={{cursor: "pointer"}}
                                            />
                                        </a>
                                    </div>
                                </Grid>
                            </Grid>

                            <Divider sx={{my: 3, bgcolor: "#555"}}/>

                            <Typography variant="caption" sx={{color: "#aaa"}}>
                                © {new Date().getFullYear()} Hamekara.com - کلیه حقوق محفوظ است
                            </Typography>
                        </Box>
                    </React.Fragment>
                )}
            </>
        );
    }
}
